import * as React from 'react'
import { PreviewCard as BasePreviewCard } from '@base-ui/react/preview-card'
import type { PartProps } from '../../../lib/part-props'

export interface PortalProps extends PartProps<React.ComponentProps<typeof BasePreviewCard.Portal>> {}

export function Portal(props: PortalProps) {
  return <BasePreviewCard.Portal {...props} />
}
